import { VersionTag } from '../../../../types/VersionTag'
import { GameVersion } from '../types/GameAnalyses'

// Legacy sends the active tags in the language map's order, not the stored order.
export const getVersionTagsBody = (activeIds: string[], versionTags: VersionTag[]) => {
  const known = versionTags.map(({ id }) => id)
  return [...known.filter((id) => activeIds.includes(id)), ...activeIds.filter((id) => !known.includes(id))]
}

export const toggleVersionTag = (activeIds: string[], id: string) => (activeIds.includes(id) ? activeIds.filter((active) => active !== id) : [...activeIds, id])

export const haveSameTags = (a?: string[] | null, b?: string[] | null) => {
  const left = new Set(a ?? [])
  const right = new Set(b ?? [])
  return left.size === right.size && Array.from(left).every((id) => right.has(id))
}

export type VersionTagsSaveImpact = {
  selectedIsAutomatic: boolean
  differingMarketIsos: string[]
}

// A save writes the tags to the version in every market and sets `overrideTags`. Only the markets already loaded can be
// checked, so an automatically tagged selected market also asks for confirmation: other markets may well differ.
export const getVersionTagsSaveImpact = (
  version: Pick<GameVersion, 'version' | 'tags' | 'overrideTags'>,
  marketIso: string,
  loadedVersionsByMarket: Record<string, Pick<GameVersion, 'version' | 'tags' | 'overrideTags'>[] | undefined>
): VersionTagsSaveImpact => ({
  selectedIsAutomatic: !version.overrideTags,
  differingMarketIsos: Object.entries(loadedVersionsByMarket)
    .filter(([iso, versions]) => {
      if (iso === marketIso) return false
      const other = versions?.find((candidate) => candidate.version === version.version)
      return !!other && (!other.overrideTags || !haveSameTags(other.tags, version.tags))
    })
    .map(([iso]) => iso)
    .sort(),
})

export const needsVersionTagsSaveConfirmation = ({ selectedIsAutomatic, differingMarketIsos }: VersionTagsSaveImpact) =>
  selectedIsAutomatic || differingMarketIsos.length > 0

export const getReleaseNotes = (version: Pick<GameVersion, 'releaseNotes' | 'description'>) => version.releaseNotes || version.description
